import React from 'react';
import {
  Box,
  Grid,
  HStack,
  Skeleton,
  Stat,
  StatLabel,
  StatNumber,
  Text,
  VStack,
} from '@chakra-ui/react';
import { FiClipboard, FiUser, FiCheckCircle, FiClock } from 'react-icons/fi';
import { SaktiBkmKpiData } from '../types';
import { SAKTI_UI_SIZE } from '../uiSizes';

interface SaktiBkmKpiCardsProps {
  loading: boolean;
  data: SaktiBkmKpiData;
}

const formatNumber = (value: number) => value.toLocaleString('id-ID');

const SaktiBkmKpiCards: React.FC<SaktiBkmKpiCardsProps> = ({ loading, data }) => {
  const avgHa = data.total_harvesters > 0 ? data.total_ha / data.total_harvesters : 0;
  
  const cards = [
    { key: 'total-ha', label: 'TOTAL HA HARI INI', value: data.total_ha.toFixed(2), unit: 'ha', icon: FiClipboard, color: 'green' },
    { key: 'avg-ha', label: 'HA PER PEMANEN (AVG)', value: avgHa.toFixed(2), unit: 'ha', icon: FiUser, color: 'blue' },
    { key: 'synced', label: 'BKM SYNCED', value: formatNumber(data.total_bkm), unit: 'record', icon: FiCheckCircle, color: 'purple' },
    { key: 'pending', label: 'PENDING', value: '0', unit: 'record', icon: FiClock, color: 'orange' },
  ];

  return (
    <Grid templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)', xl: 'repeat(4, 1fr)' }} gap={3}>
      {cards.map((card) => (
        <Skeleton key={card.key} isLoaded={!loading} borderRadius={SAKTI_UI_SIZE.cardRadius}>
          <Box bg="white" borderRadius={SAKTI_UI_SIZE.cardRadius} p={SAKTI_UI_SIZE.cardPadding} borderWidth="1px" borderColor="gray.200">
            <VStack align="stretch" spacing={3}>
              <HStack justify="space-between" align="start">
                <Box bg={`${card.color}.50`} color={`${card.color}.600`} borderRadius="md" p={1.5} display="inline-flex" alignItems="center" justifyContent="center" boxSize={SAKTI_UI_SIZE.kpiIconBoxSize}>
                  <card.icon />
                </Box>
              </HStack>
              <Stat>
                <StatLabel fontSize={SAKTI_UI_SIZE.kpiLabel} letterSpacing="wider" color="gray.500">{card.label}</StatLabel>
                <HStack align="end" spacing={1}>
                  <StatNumber fontSize={SAKTI_UI_SIZE.kpiValue}>{card.value}</StatNumber>
                  <Text color="gray.500" pb={1} fontSize="xs">{card.unit}</Text>
                </HStack>
              </Stat>
            </VStack>
          </Box>
        </Skeleton>
      ))}
    </Grid>
  );
};

export default SaktiBkmKpiCards;
